import React from 'react';
import { Chip } from '@mui/material';

const StatusBadge = ({ status }) => {

  const getStatusConfig = (status) => {
    const configs = {
      draft: {
        label: 'Draft',
        color: 'default',
        bgColor: '#e5e7eb',
        textColor: '#374151'
      },
      scheduled: {
        label: 'Scheduled',
        color: 'info',
        bgColor: '#e0e7ff',
        textColor: '#3730a3'
      },
      sent: {
        label: 'Sent',
        color: 'info',
        bgColor: '#dbeafe',
        textColor: '#1e40af'
      },
      paid: {
        label: 'Paid',
        color: 'success',
        bgColor: '#d1fae5',
        textColor: '#065f46'
      },
      partially_paid: {
        label: 'Partially Paid',
        color: 'warning',
        bgColor: '#fef3c7',
        textColor: '#92400e'
      },
      overdue: {
        label: 'Overdue',
        color: 'error',
        bgColor: '#fee2e2',
        textColor: '#991b1b'
      },
      cancelled: {
        label: 'Cancelled',
        color: 'default',
        bgColor: '#f3f4f6',
        textColor: '#6b7280'
      }
    };

    return configs[status] || { label: status, color: 'default', bgColor: '#e5e7eb', textColor: '#374151' };
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        backgroundColor: config.bgColor,
        color: config.textColor,
        fontWeight: 500,
        fontSize: '0.75rem'
      }}
    />
  );
};

export default StatusBadge;
